import axios from 'axios';

const requests = axios.create({
    baseURL: "http://zz.whhzys.cn",
    timeout: 50000
});

requests.interceptors.request.use((config) => {
    return config
});

requests.interceptors.response.use((res) => {
    if (res.status == 200 && res.data.code == 200) {
        return Promise.resolve(res.data)
    } else {
        return Promise.reject(res.data)
    }

}, (error) => {
    const data = error.response?.data;
    return Promise.reject(data || { msg: error.message || '网络错误,请稍后再试！' });
})
export default requests;
